let map;
let markers = [];
let AdvancedMarkerClass
const brasilCoordinates = { lat: -14.58226, lng: -55.51321 }
const mapDefaultZoom = 3.58

const hideModal = () => {
  const modalElement = document.querySelector('.map-modal');
  modalElement.classList.add('hide');
}

const showModal = (lat, lng) => {
  const chosenElement = document.querySelector(`[data-latitude="${lat}"][data-longitude="${lng}"]`);
  if (!chosenElement) return;

  const branchName = chosenElement.querySelector('.branches-list-left h3').textContent
  const branchImage = chosenElement.querySelector('.image-wrapper').innerHTML
  const branchAddress = chosenElement.querySelector('.branches-list-center>.address').innerHTML
  const branchPhones = chosenElement.querySelector('.branches-list-center>.phones').innerHTML

  const modalElement = document.querySelector('.map-modal');
  const modalTitleElement = modalElement.querySelector('.map-modal-title')
  const modalImageElement = modalElement.querySelector('.image-wrapper')
  const modalAddressElement = modalElement.querySelector('.addess-content')
  const modalPhonesElement = modalElement.querySelector('.phones-content')

  modalTitleElement.innerHTML = branchName
  modalImageElement.innerHTML = branchImage
  modalAddressElement.innerHTML = branchAddress
  modalPhonesElement.innerHTML = branchPhones

  modalElement.classList.remove('hide');

  map.setCenter({ lat, lng })
  map.setZoom(6)
}

const showOnMap = (lat, lng) => {
  for (let i = 0; i < markers.length; i++) {
    markers[i].setMap(null);
  }

  addMarker({ lat, lng })
  map.setCenter({ lat, lng })
  map.setZoom(6)

  showModal(lat, lng)
  document.getElementById('map')?.scrollIntoView({ behavior: 'smooth', block: 'center' })
}

const addMarker = async (position) => {
  if (!AdvancedMarkerClass) {
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker")
    AdvancedMarkerClass = AdvancedMarkerElement
  }

  const newMarker = new AdvancedMarkerClass({ position, map });
  newMarker.addListener("click", () => showModal(position.lat, position.lng))

  markers.push(newMarker);
}

const updateMapMarkers = () => {
  const mapElement = document.getElementById("map")
  if (!mapElement) return;

  const selectedState = document.getElementById("branches-list-state-selector").value;
  const branchesListItems = document.querySelectorAll('.branches-list li:not(.hide)');

  for (let i = 0; i < markers.length; i++) {
    markers[i].setMap(null);
  }

  branchesListItems.forEach((branchListItem, i) => {
    const lat = parseFloat(branchListItem.getAttribute('data-latitude'));
    const lng = parseFloat(branchListItem.getAttribute('data-longitude'));

    addMarker({ lat, lng })

    if (selectedState && (i === (branchesListItems.length - 1))) {
      map.setCenter({ lat, lng })
      map.setZoom(6)
    }
  });

  if (!selectedState) {
    map.setCenter(brasilCoordinates)
    map.setZoom(mapDefaultZoom)
  }
}

const initMap = async () => {
  const mapElement = document.getElementById("map");
  if (!mapElement) return

  const { Map } = await google.maps.importLibrary("maps");

  map = new Map(mapElement, {
    zoom: mapDefaultZoom,
    center: brasilCoordinates,
    mapId: '4504f8b37365c3d0',
  });

  const branchesListItems = document.querySelectorAll('.branches-list li');

  branchesListItems.forEach(branchListItem => {
    const lat = parseFloat(branchListItem.getAttribute('data-latitude'));
    const lng = parseFloat(branchListItem.getAttribute('data-longitude'));

    addMarker({ lat, lng })
  });
}

const handleBranchesStateSelector = () => {
  const selectedState = document.getElementById("branches-list-state-selector").value;
  const citySelectorElement = document.getElementById("branches-list-city-selector");

  const branchesListItems = document.querySelectorAll('.branches-list li');
  let cities = [];

  if (selectedState)
    citySelectorElement.removeAttribute("disabled")
  else
    citySelectorElement.disabled = true


  branchesListItems.forEach(item => {
    const state = item.getAttribute('data-state');

    if (!selectedState) {
      item.classList.remove('hide');
      return
    }

    if (state === selectedState) {
      item.classList.remove('hide');

      const city = item.getAttribute('data-city');
      cities.push(city);
    } else
      item.classList.add('hide');
  });

  citySelectorElement.innerHTML = `<option selected value="">Cidade</option>`
  citySelectorElement.value = ""
  const filteredCities = new Set([...cities.sort()])
  filteredCities.forEach(city => {
    citySelectorElement.innerHTML += `<option value="${city}">${city}</option>`
  });

  hideModal()
  updateMapMarkers()
}

const handleBranchesCitySelector = () => {
  const selectedState = document.getElementById("branches-list-state-selector").value;
  const selectedCity = document.getElementById("branches-list-city-selector").value;

  const branchesListItems = document.querySelectorAll('.branches-list li');

  branchesListItems.forEach(item => {
    const city = item.getAttribute('data-city');
    const state = item.getAttribute('data-state');

    if (!selectedCity && selectedState && (state === selectedState)) {
      item.classList.remove('hide');
      return
    }

    if ((city === selectedCity) && (state === selectedState))
      item.classList.remove('hide');
    else
      item.classList.add('hide');

    hideModal()
  });

  updateMapMarkers()
}

const verifyGoogle = () => {
  if (window?.google?.maps?.importLibrary) initMap()
  else setTimeout(verifyGoogle, 100);
}

verifyGoogle();